import { Controller } from "stimulus";
import $ from "jquery";
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");

export default class extends Controller {
  static targets = ["primarySelect", "secondarySelect"];

  connect() {
    $(this.primarySelectTarget).select2({
      width: "100%",
      placeholder: "Select primary organization",
      allowClear: false
    });

    $(this.secondarySelectTarget).select2({
      width: "100%",
      placeholder: "Select secondary organizations (optional)",
      allowClear: true
    });

    $(this.primarySelectTarget).on("change.studyForm", () => this.syncSecondaryOptions());
    this.syncSecondaryOptions();
  }

  disconnect() {
    $(this.primarySelectTarget).off("change.studyForm");
    this.destroySelect2(this.primarySelectTarget);
    this.destroySelect2(this.secondarySelectTarget);
  }

  syncSecondaryOptions() {
    const primaryId = $(this.primarySelectTarget).val();
    const $secondary = $(this.secondarySelectTarget);
    const selected = ($secondary.val() || []).filter((id) => id !== primaryId);

    $secondary.find("option").each((_, option) => {
      option.disabled = primaryId !== "" && option.value === primaryId;
    });

    $secondary.val(selected).trigger("change.select2");
  }

  destroySelect2(element) {
    const $element = $(element);
    if ($element.hasClass("select2-hidden-accessible")) {
      $element.select2("destroy");
    }
  }
}
